import styled from "styled-components";
import { Form } from "@unform/web";
import { MdKeyboardArrowRight, MdSubdirectoryArrowRight } from "react-icons/md";
import { Typography } from "../../components";

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const ContainerLeft = styled.div`
  background-attachment: fixed;
  background-size: cover;
  display: flex;
  justify-content: space-around;
  /* background-image: url("https://images.pexels.com/photos/5088178/pexels-photo-5088178.jpeg"); */
  width: 100%;
  height: 100vh;
  /* background-size: cover; */
  align-items: center;
  /* background-attachment: fixed; */

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

const ContainerRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 500px;
  }
  @media (max-width: 1040px) {
    display: none;
  }
`;

const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  /* width: 400px; */
  max-height: 310px;
  justify-content: space-around;
`;

const ContainerAuth = styled.div`
  background-color: #fff;
  border-radius: 5px;
  margin-right: 30px;
  padding: 60px 30px;
  width: 400px;
  position: relative;
  @media (max-width: 1024px) {
    /* width: 100%; */
  }
  @media (max-width: 720px) {
    width: 100%;
    height: 100%;
    margin-right: initial;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 30px;
  }
`;

const BoxText = styled.div`
  margin-bottom: 25px;
`;

const Title = styled.div`
  font-size: 25px;
  margin: 15px 0px;
`;

const InputPassword = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const TextPassword = styled(Typography)`
  margin-top: 15px;
  text-align: center;
`;

const UserServices = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  height: 100%;
  background-color: #fff;
  padding: 0px 40px;
  @media (max-width: 1024px) {
    /* width: 100%; */
    padding: 0px 10px;
  }
  @media (max-width: 720px) {
    width: 100%;
    height: 100%;
    margin-right: initial;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 30px;
  }
`;
const UserInfo = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: space-around; */
`;
const Services = styled.div``;
const CardService = styled.div`
  max-width: 400px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-top: 10px;
  border-bottom: 1px solid ${(props) => props.theme.palette.grey[50]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background-color: ${(props) => props.theme.palette.grey[100]};
  }
  &:hover .IconCard {
    margin-right: initial;
  }
`;

const TextEmail = styled.span`
  margin: 0 10px;
`;

const ContentAuth = styled.div`
  margin: 10px;
`;
const ContentCard = styled.div``;

const IconCard = styled(MdKeyboardArrowRight)`
  font-size: 30px;
  transition: 0.3s;
  margin-right: 10px;
  color: ${(props) => props.theme.palette.grey[500]};
`;

const IconDirect = styled(MdSubdirectoryArrowRight)`
  font-size: 30px;
  color: ${(props) => props.theme.palette.grey[500]};
  padding: 0 10px;
`;

const MensageError = styled.span`
  color: red;
  margin-bottom: 15px;
`;

const TextNotAcess = styled(Typography)`
  margin: 0 5px;
  color: #000000a3;
  font-weight: 500;
  cursor: pointer;
`;

const TextTermsOfUse = styled(Typography)`
  margin: 0 5px;
  color: #000000a3;
  font-weight: 500;
  cursor: pointer;
`;

const FooterAuth = styled.div`
  position: absolute;
  bottom: 11px;
  right: 15px;
`;

const Img1M = styled.img`
  display: none;
  width: 400px;
  height: 263px;
  bottom: 10px;
  position: absolute;
  object-fit: contain;
  @media (max-width: 1024px) {
    width: 250px;
    height: 203px;
    position: absolute;
    left: 0;
    top: 0;
    margin: 10px;
    z-index: 9999;
    justify-content: center;
    margin: 0 auto;
    width: 100%;
    display: initial;
  }
`;

const Img1 = styled.img`
  width: 400px;
  height: 263px;
  max-width: 400px;
  max-height: 263px;
  bottom: 10px;
  position: absolute;
  object-fit: contain;
`;

const Img2 = styled.img`
  width: 400px;
  height: 263px;
  max-width: 400px;
  max-height: 263px;
  object-fit: contain;
`;

const ContainerRigth = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 50%;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    display: none;
  }
`;

const Logo = styled.img`
  width: 150px;
  max-width: 150px;
  object-fit: contain;
  max-height: 125px;
`;

const ManualDoAluno = styled.a`
  text-align: center;
  margin-top: 15px;
  cursor: pointer;
`;

const ContainerManuais = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ButtonManual = styled.button`
  background-color: #52ae9d;
  margin-top: 10px;
  border-radius: 4px;
  border: none;
  width: 100%;
  height: 50px;
  padding: 10px;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
`;

const ButtonCloseModal = styled.button`
  position: absolute;
  right: 20px;
  background-color: #52ae9d;
  border-radius: 4px;
  border: none;
  padding: 10px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
`;
export {
  Container,
  ContainerLeft,
  ContainerRight,
  ContainerAuth,
  FormContainer,
  BoxText,
  Title,
  InputPassword,
  TextPassword,
  UserServices,
  UserInfo,
  Services,
  CardService,
  TextEmail,
  ContentAuth,
  ContentCard,
  IconCard,
  IconDirect,
  MensageError,
  TextNotAcess,
  TextTermsOfUse,
  FooterAuth,
  Img1,
  ContainerRigth,
  Logo,
  Img2,
  Img1M,
  ManualDoAluno,
  ContainerManuais,
  ButtonManual,
  ButtonCloseModal,
};
